export default {
    en: {
        survey_title:"Beta Tester Special Survey",
        survey_desc1:"Hello, this is the PM AutoTwin team.",
        survey_desc2:"Thank you so much for participating in the PM AutoTwin beta test.",
        survey_desc3:"To help us improve our service, we'd appreciate your feedback in this brief survey.",
        survey_desc4:"As a token of our gratitude, we'll provide you with 10 additional credits upon completion.",
        survey_desc5:"Your valuable opinions are a driving force in making PM AutoTwin better.",
        survey_desc6:"Thank you!🙏",
   
        send_survey:"Submit",
    },
    ko: {
        survey_title:"베타테스트 특별 설문조사",
        survey_desc1:"안녕하세요, PM AutoTwin팀 입니다.",
        survey_desc2:"PM AutoTwin 베타테스트에 참여해 주셔서 진심으로 감사합니다.",
        survey_desc3:'더 나은 서비스를 위해 간단한 설문조사에 응답해주시면, 감사의 의미로 추가 크레딧 10개를 제공해 드립니다.',
        survey_desc4:" ",
        survey_desc5:"여러분의 소중한 의견이 PM AutoTwin을 발전시키는 큰 힘이 됩니다.",
        survey_desc6:"감사합니다.🙏",
        
        send_survey:"제출",
    },
    ja: {
        survey_title:"ベータテスター特別アンケート",
        survey_desc1:"こんにちは、PM AutoTwinチームです。",
        survey_desc2:"PM AutoTwinのベータテストにご参加いただき、誠にありがとうございます。",
        survey_desc3:'より良いサービスのために簡単なアンケートにご回答いただけますと、感謝の気持ちとして追加クレジット10個を提供いたします。',
        survey_desc4:" ",
        survey_desc5:"皆様の貴重なご意見が、PM AutoTwinを発展させる大きな力となります。",
        survey_desc6:"ありがとうございます。🙏",
        
        send_survey:"送信",
    },
};

